/** Display costs for AI tools. The pricing table and Generate badge use these. */
export const AI_OPERATION_CREDITS = {
  remove_bg: 1,
  ai_background: 2,
  ai_shadow: 2,
  outpaint: 2,
  remove_object: 2,
  replace_object: 2,
};

/**
 * 2× is 2 credits, 4× is 4.
 * Balanced adds 1 credit. Best adds 2. Fast stays at the scale price.
 */
export function upscaleCreditCost(scaleId = "2x", presetId = "balanced") {
  const scale = String(scaleId || "2x").toLowerCase();
  const preset = String(presetId || "").toLowerCase();
  const base = scale === "4x" ? 4 : 2;
  const quality = preset === "best" ? 2 : preset === "balanced" ? 1 : 0;
  return base + quality;
}

/** Locked UI cost for a pricing task key. Upscale without options is 2× Balanced. */
export function uiCreditCostForTask(taskKey, options) {
  if (taskKey === "upscale") {
    return upscaleCreditCost(options?.scale, options?.quality ?? options?.preset);
  }
  const locked = AI_OPERATION_CREDITS[taskKey];
  return locked == null ? null : locked;
}
